import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    connect,
    Provider,
} from 'react-redux';
import { bindActionCreators } from 'redux';
import { ConnectedRouter } from 'connected-react-router';

import { createHashHistory as createHistory } from 'history';

import initReactApp, { extractParams } from 'helpers/InitHelpers';
import { extractQueryParameters } from 'helpers/RoutesHelpers';
import { getLocationSelector } from '../commons/selectors/RouterSelector';

import configureStore from './Store';

import GodBuster from '../components/GodBuster';

import {
    initContactSupportApp,
    openModal,
} from './reduxModules/App';

import SupportModal from './components/SupportModal';
import ConsentManagementPlatformPortal from '../consentManagementPlatform/ConsentManagementPlatformPortal';

export const appSelector = '#js-app-contact-form';

class SupportModalStandAlone extends Component {

    constructor(props) {
        super(props);
        this.onOpenModal = this.onOpenModal.bind(this);
    }

    componentDidMount() {
        const { AppActions } = this.props;
        AppActions.initContactSupportApp();
    }

    onOpenModal() {
        const { AppActions } = this.props;
        AppActions.openModal({});
    }

    renderModalContent() {
        const { history, location } = this.props;
        const supportModalLocation = {
            pathname: '',
            search: '',
            hash: '',
        };
        if (history && location) {
            supportModalLocation.pathname = extractQueryParameters(location.search)['support-modal'] || '';
        }
        return (
            <ConnectedRouter history={history}>
                <SupportModal location={supportModalLocation} />
            </ConnectedRouter>
        );
    }

    render() {
        const { history } = this.props;
        return (
            <GodBuster>
                {this.renderModalContent()}
                <a
                    className="c-topnav__right c-topnav__link"
                    onClick={this.onOpenModal}
                >
                    Aide
                </a>
                <ConnectedRouter history={history}>
                    <ConsentManagementPlatformPortal />
                </ConnectedRouter>
            </GodBuster>
        );
    }

}

SupportModalStandAlone.propTypes = {
    AppActions: PropTypes.shape({
        initContactSupportApp: PropTypes.func.isRequired,
        openModal: PropTypes.func.isRequired,
    }).isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object,
};

SupportModalStandAlone.defaultProps = {
    location: {},
};

function mapStateToProps(state) {
    return {
        location: getLocationSelector(state),
    };
}

const ConnectedApp = connect(mapStateToProps, (dispatch) => ({
    AppActions: bindActionCreators({
        initContactSupportApp,
        openModal,
    }, dispatch),
}))(SupportModalStandAlone);

export default ConnectedApp;

export function initContactFormApp() {
    if (!document.querySelector(appSelector)) return;
    const params = extractParams(appSelector);
    const history = createHistory();
    const store = configureStore({
        AppFormContact: {
            orgaId: Number.parseInt(params['orga-id'], 10),
            currentEventType: '',
            currentPhone: '',
            currentEmail: '',
            currentMessage: '',
            currentName: '',
            currentQuestionType: '',
            questionErrorsDisplayed: false,
            isSending: false,
        },
    }, history);
    initReactApp(appSelector, (
        <Provider store={store}>
            <ConnectedApp
                history={history}
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                {...params}
            />
        </Provider>
    ));
}

initContactFormApp();
